<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-30 
-->
<template>
  <div class="main-container">
    <page-header>{{'参展申请' | dealLanguage('Exhibition application')}}</page-header>
    <div class="center-wrapper">
      <div class="top-tip" v-if="language == 'zh'">
        您好，感谢您关注<span>{{activityDetail.name}}</span>！<br />
        填写参展申请信息，工作人员会尽快与您联系。<br />
        如有任何问题，敬请咨询<span>18600925630</span>。
      </div>
      <div class="top-tip" v-if="language == 'en'">
        Thank you for your attention in <span>{{activityDetail.enName}}</span>！<br />
        Please fill in the exhibition application information and our staff will contact you as soon as possible. <br />
        If you have any questions, please contact the CSGCT Secretariat via email: <span>join@csgst.com.cn</span>.
      </div>
      <div class="form-view">
        <Form ref="current-form" :model="currentForm" :rules="ruleValidate">
          <div class="view-title">
            <div class="title">{{'赞助及参展信息登记' | dealLanguage('Sponsor & Exhibitor Application')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="entityName" :label="'公司' | dealLanguage('Company Name')">
            <Input type="text" v-model="currentForm.entityName" :placeholder="'请填写公司名称'| dealLanguage('Please fill in the company name')"></Input>
          </FormItem>
          <FormItem prop="contactName" :label="'联系人姓名' | dealLanguage('Name')">
            <Input type="text" v-model="currentForm.contactName" :placeholder="'请填写联系人姓名'| dealLanguage('Please fill in your name')"></Input>
          </FormItem>
          <Row :gutter="26" v-if="language == 'zh'">
            <Col span="6">
            <FormItem prop="mobileAreaCode" :label="'国家地区码' | dealLanguage('Area Code')">
              <Select v-model="currentForm.mobileAreaCode" :disabled="currentPartnerId" :placeholder="'请选择国家/地区码' | dealLanguage('Please select a country/region code')">
                <Option v-for="item in appMobileAreaCodeDtos" :value="item.mobileAreaCode" :key="item.mobileAreaCode">+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem prop="mobile" label="手机号码">
              <Input type="text" class="right-padding" :disabled="isVerifyCode" v-model="currentForm.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
              <Captcha ref="captcha" scene="vbdata_loginon" :mobile="currentForm.mobile" :mobileAreaCode="currentForm.mobileAreaCode" v-if="!isVerifyCode" captchaButtonId="sign-captcha-button" captchaElementId="sign-captcha-element"></Captcha>
              <Button type="text" class="code-btn" v-else @click="handleUpdateMobile">更新手机号</Button>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem prop="verifyCode" label="验证码">
              <Input type="text" v-model="currentForm.verifyCode" :disabled="isVerifyCode" placeholder="请填写验证码"></Input>
              <div class="verify-success" v-if="isVerifyCode">
                <i class="iconfont">&#xe71d;</i>
                <span>验证成功</span>
              </div>
            </FormItem>
            </Col>
          </Row>
          <FormItem prop="email" v-if="language == 'zh'" label="E-mail">
            <Input type="text" v-model="currentForm.email" placeholder="请填写邮箱"></Input>
          </FormItem>
          <Row :gutter="26" v-else>
            <Col span="12">
            <FormItem prop="email" label="E-mail">
              <Input type="text" class="right-padding" :disabled="isVerifyCode" v-model="currentForm.email" placeholder="Please fill in your email"></Input>
              <Captcha ref="captcha" validMode="2" scene="vbdata_loginon" :email="currentForm.email" v-if="!isVerifyCode" captchaButtonId="sign-email-captcha-button" captchaElementId="sign-email-captcha-element"></Captcha>
              <Button type="text" class="code-btn" v-else @click="handleUpdateMobile">Update E-mail</Button>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem prop="verifyCode" label="E-mail Verification Code">
              <Input type="text" v-model="currentForm.verifyCode" :disabled="isVerifyCode" placeholder="Please enter the verification code"></Input>
              <div class="verify-success" v-if="isVerifyCode">
                <i class="iconfont">&#xe71d;</i>
                <span>Verification successful</span>
              </div>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="26">
            <Col span="12">
            <FormItem prop="department" :label="'部门' | dealLanguage('Department')">
              <Input type="text" v-model="currentForm.department" :placeholder="'请填写部门'| dealLanguage('Please fill in the department')"></Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
              <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位'| dealLanguage('Please fill in the position')"></Input>
            </FormItem>
            </Col>
          </Row>
          <FormItem prop="summary" :label="'主推/主营产品名称' | dealLanguage('Main Products')">
            <Input type="text" v-model="currentForm.summary" :placeholder="'请填写主推/主营产品名称'| dealLanguage('Please fill in the name of the main product')"></Input>
          </FormItem>
          <FormItem prop="mainPage" :label="'公司网址' | dealLanguage('Company Websits')">
            <Input type="text" v-model="currentForm.mainPage" :placeholder="'请填写公司网址'| dealLanguage('Please fill in the company website')"></Input>
          </FormItem>
          <FormItem prop="need" :label="'主要参展需求（多选）' | dealLanguage('Requirements(multi-select)')">
            <CheckboxGroup v-model="currentForm.need" @on-change="handleChangeNeed">
              <Checkbox :label="item" v-for="item,index in needList" :key="index"></Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem prop="needother" v-if="needother">
            <Input type="text" v-model="currentForm.needother" :placeholder="'请填写具体需求'| dealLanguage('Please fill in your specific requirements')"></Input>
          </FormItem>
        </Form>
        <div class="btn-wrapper">
          <Button type="primary" @click="handleSubmit" :loading="buttonLoading">
            <span v-if="buttonLoading">{{'提交中' | dealLanguage('Loading')}}</span>
            <span v-else>{{'提交' | dealLanguage('Submit')}}</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addCompEnrollment } from '@/service/vbef'
import { Alogin } from '@/service/app'
import Captcha from '@/components/common/captcha'
import PageHeader from '@/components/pc/pageHeader.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('参展申请', 'Exhibition application'),
    }
  },
  inject: ['login'],
  components: {
    PageHeader,
    Captcha,
  },
  created() {
    // if (this.user_key) {
    //   this.currentForm.contactName = this.user.name
    //   this.currentForm.mobile = this.user.mobile
    //   this.currentForm.entityName = this.user.compName
    //   this.currentForm.department = this.user.department
    //   this.currentForm.title = this.user.title
    // }
  },
  mounted() {},
  data() {
    const _this = this
    return {
      filter,
      buttonLoading: false,
      currentForm: {
        activityId: 0,
        contactName: '',
        department: '',
        entityName: '',
        email: '',
        mainPage: '',
        mobile: '',
        verifyCode: '',
        summary: '',
        title: '',
        need: [],
        needother: '',
        mobileAreaCode: '86',
      },
      ruleValidate: {
        contactName: [
          {
            required: true,
            message: filter.dealLanguage('请填写姓名', 'Please fill in your name'),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
          {
            type: 'number',
            message: filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect'
            ),
            trigger: 'blur',
            transform(value) {
              if (_this.currentForm.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
        email: [
          {
            required: true,
            message: filter.dealLanguage('请填写邮箱', 'Please fill in your email'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: filter.dealLanguage('邮箱格式不正确', 'The email format is incorrect'),
            trigger: 'blur',
          },
        ],
        verifyCode: [
          {
            required: true,
            message: filter.dealLanguage(
              '请输入验证码',
              'Please enter the verification code'
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateCode,
          },
        ],
        entityName: [
          {
            required: true,
            message: filter.dealLanguage('请填写企业名称', 'Please fill in the company name'),
            trigger: 'blur',
          },
        ],
        department: [
          {
            required: true,
            message: filter.dealLanguage('请填写部门', 'Please fill in the department'),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: filter.dealLanguage('请填写职位', 'Please fill in the position'),
            trigger: 'blur',
          },
        ],
        need: [
          {
            required: true,
            type: 'array',
            message: filter.dealLanguage(
              '请选出主要参展需求',
              'Please select your main exhibition requirements'
            ),
            trigger: 'change',
          },
        ],
        needother: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写具体需求',
              'Please fill in the specific requirements'
            ),
            trigger: 'blur',
          },
        ],
        summary: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写主推/主营产品名称',
              'Please fill in the name of the main product'
            ),
            trigger: 'blur',
          },
        ],
      },
      needother: false,
      isVerifyCode: false,
      needList: [
        filter.dealLanguage(
          '大会联合主办单位/大会协办单位赞助',
          'Annual Meeting Co-organizer/Supported by'
        ),
        filter.dealLanguage(
          '大会分论坛联合主办单位/大会分论坛协办单位赞助',
          'Sub-forum Co-organizer/ Supported by'
        ),
        filter.dealLanguage(
          '大会主论坛演讲/圆桌赞助',
          'Keynote Speech/Panel Sponsorship (Main Forum)'
        ),
        filter.dealLanguage('大会分论坛演讲/圆桌赞助', 'Speech/Panel Sponsorship (Sub-forum)'),
        filter.dealLanguage('申请展位参展', 'Apply for a exhibitor'),
        filter.dealLanguage('在大会同期自主举办独立卫星会', 'Host a satellite meeting'),
        filter.dealLanguage('在大会现场进行线下赞助', 'Apply for a sponsor'),
        // filter.dealLanguage('其他', 'Others'),
      ],
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      language: (state) => state.language,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      isMobile: (state) => state.isMobile,
    }),
  },
  methods: {
    handleSubmit() {
      if (this.buttonLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          this.currentForm.activityId = this.activityId
          let needJson = {
            need: this.currentForm.need,
            needother: this.currentForm.needother,
          }
          this.currentForm.checkFormJson = JSON.stringify(needJson)
          const { need, needother, verifyCode, ...params } = this.currentForm
          let res = await addCompEnrollment(params)
          this.buttonLoading = false
          if (res.code == 0) {
            this.$Modal.success({
              title: this.language == 'zh' ? '提交成功！' : 'Summit successfully!',
              content:
                this.language == 'zh'
                  ? `您填写的表格内容已提交成功`
                  : `The content of the form you filled out has been successfully submitted`,
              onOk: () => {
                this.$router.push({ name: 'index' })
              },
              okText: filter.dealLanguage('返回首页', 'Return Home'),
            })
          } else {
            this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        } else {
          this.$Message.error(filter.dealLanguage('存在未完善选项，请上滑查看', 'There are incomplete options. Please swipe up to view'))
        }
      })
    },
    handleChangeNeed(arr) {
      this.needother = false
      for (let item of arr) {
        if (item.indexOf('其他') > -1 || item.indexOf('Other') > -1) {
          this.needother = true
          break
        }
      }
    },
    async validateCode(rule, value, callback) {
      if (this.isVerifyCode) {
        callback()
        return
      }

      let params = {
        loginPlatform: this.isMobile ? 9 : 8,
        type: this.language == 'zh' ? 2 : 11,
        email: this.currentForm.email || '',
        mobileAreaCode: this.currentForm.mobileAreaCode || '',
        mobile: this.currentForm.mobile || '',
        code: this.currentForm.verifyCode,
      }
      let res = await Alogin(params)
      if (res.code == 0) {
        this.$store.commit('updateInterimUserKey', res.data.userKey)
        this.isVerifyCode = true
        callback()
      } else {
        this.$store.commit('updateInterimUserKey', null)
        this.isVerifyCode = false
        callback(new Error(filter.dealLanguage(res.msg, res.enMsg)))
      }
    },
    handleUpdateMobile() {
      this.$store.commit('updateInterimUserKey', null)
      this.isVerifyCode = false
      this.currentForm.mobile = ''
      this.currentForm.verifyCode = ''
      if (this.language != 'zh') this.currentForm.email = ''
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'
.center-wrapper
  padding 20px 0 30px
  .top-tip
    font-size 16px
    color #3D3D3D
    line-height 28px
    text-align justify
    span
      color #C8161D
  .btn-wrapper
    margin-top 14px
    text-align center
  .form-btn
    color #fff
    background-color #C8161D
    border-color #C8161D
    box-shadow none
    transition all 0.3s
    width 100%
    height 40px
    font-size 16px
    margin-top 24px
    &:hover
      background-color #E24147
      border-color #E24147
</style>
